import {Trans} from '@lingui/macro';
import React, {useEffect, useState} from 'react';

import {SingleChoiceDropdown} from '../dropdowns/singleChoiceDropdown';
import {defaultDropdownWidth, GenericSingleParameterProps} from './genericParameter';

/*
 * Types.
 */

export interface TimezoneModel {
  id: string;
  name: string;
}

/*
 * Component.
 */

export const TimezoneParameter = (props: GenericSingleParameterProps<TimezoneModel>) => {
  const timezones = useTimezones();

  if (!timezones.length) {
    return null;
  }

  return (
    <SingleChoiceDropdown
      {...props}
      items={timezones}
      getItemKey={(item) => String(item.id)}
      renderItemLabel={(item) => item.name}
      serializeItemForSearch={(item) => item.name}
      width={defaultDropdownWidth}
      placeholder={<Trans id="rule-editor-select-timezone">Select a timezone</Trans>}
    />
  );
};

/*
 * Helpers.
 */

function useTimezones() {
  const [zones, setZones] = useState<ReadonlyArray<TimezoneModel>>([]);
  useEffect(() => {
    (async () => {
      // https://bundlephobia.com/result?p=tzdata@1.0.25
      // We need all the possible timezones
      // @ts-expect-error
      const tzdata = await import(/* webpackChunkName: 'tzdata' */ 'tzdata');
      setZones(
        Object.keys(tzdata.default.zones)
          .sort()
          .map((zoneName) => ({
            id: zoneName,
            name: zoneName,
          })),
      );
    })();
  }, []);

  return zones;
}
